import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Constants} from '../shared/constants';
import {HeaderFilterOption, LoadOptions} from '../shared/models/shared.model';
import {Observable} from 'rxjs';
import {
  GetPostalCodeMappingToMasterGridModel,
  GetPostalCodeMappingToMasterGridResultModel,
  PostalCodeMappingGridResultModel,
  PostalCodeMasterWithReportRegionListGridResultModel,
	ProcessingStatusForPostalCodeMappingModelResult
} from '../shared/models/postal-code-mapping.model';
import {HeaderFilterData} from '../shared/models/product.model';
import {ProcessingStatusForBarcodeMappingResultResult} from '../shared/models/product-barcode.model';

@Injectable({
  providedIn: 'root'
})
export class PostalCodeMappingService {

  private token = localStorage.getItem('token');
  private headers = new HttpHeaders({ 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + this.token });

  private url = Constants.devServerEndpoint + 'api/postalcodemapping';

  constructor(private httpClient: HttpClient) { }

  public getPostalCodeMappingLightGrid(param: LoadOptions): Observable<PostalCodeMappingGridResultModel> {
	return this.httpClient
		.post<PostalCodeMappingGridResultModel>(
		this.url + `/getPostalCodeMappingGrid/`, param,
		{ headers: this.headers }
		);
  }

  public getHeaderFiltersPostalCodeMappingLightGrid(param: HeaderFilterOption): Observable<HeaderFilterData[]> {
	return this.httpClient
		.post<HeaderFilterData[]>(
		this.url + `/getHeaderFiltersPostalCodeMappingLightGrid`, param,
		{ headers: this.headers }
		);
  }

  public getGetPostalCodeMappingToMasterGrid(postalCodeMappingId): Observable<GetPostalCodeMappingToMasterGridModel[]> {
	return this.httpClient
		.get<GetPostalCodeMappingToMasterGridModel[]>(
		this.url + `/getGetPostalCodeMappingToMasterGrid/${postalCodeMappingId}`,
		{ headers: this.headers }
		);
  }

  public getPostalCodeMasterWithReportRegionListGrid(param: LoadOptions): Observable<PostalCodeMasterWithReportRegionListGridResultModel> {
	return this.httpClient
		.post<PostalCodeMasterWithReportRegionListGridResultModel>(
		this.url + `/getPostalCodeMasterWithReportRegionListGrid/`, param,
		{ headers: this.headers }
		);
  }

  public getHeaderFiltersPostalCodeMasterWithReportRegionListGrid(param: HeaderFilterOption): Observable<HeaderFilterData[]> {
	return this.httpClient
		.post<HeaderFilterData[]>(
		this.url + `/getHeaderFiltersPostalCodeMasterWithReportRegionListGrid`, param,
		{ headers: this.headers }
		);
  }

  public mappingAction(productMappingOption): Observable<any> {
	return this.httpClient
		.post<any>(
		this.url + '/mappingAction', productMappingOption,
		{ headers: this.headers }
		);
  }

	public getProcessingStatusForPostalCodeMappingResult(param: LoadOptions, BarcodeMappingId: number): Observable<ProcessingStatusForPostalCodeMappingModelResult[]> {
		return this.httpClient.post<ProcessingStatusForPostalCodeMappingModelResult[]>(this.url + `/getProcessingStatusForPostalCodeMappingResult`, {param, BarcodeMappingId}, { headers: this.headers });
	}
}
